$(document).ready(function(){
    /* forms */
    function clearform(clearblock) {
        $("input[type='text'], textarea", clearblock).val("");
        $("input[type='checkbox'], input[type='radio']", clearblock).prop({"checked":false});
    }

    if($('textarea').length > 0) {
        $('textarea').on("input", function(e) {
            $this = e.target;
            $this.style.height = $this.scrollHeight + 'px';
        });
    }

    $('form').submit(function(){
        sendsform = $(this);
        inputError  = false;

        $('input, textarea', sendsform).each(function(indx, element){
            inputName = $(this).attr("name");
            inputVal = $(this).val();
            let regPhone = /^([\+0-9\-\(\)\s]{5,25})$/;
            let regMail = /^[\.A-z0-9_\-\+]+[@][A-z0-9_\-]+([.][A-z0-9_\-]+)+[A-z]{1,4}$/;
            if(inputName == "PROP[NAME]") {
                if(inputVal == "") {
                    inputError = true;
                    $(this).before('<span class="error-input">Заполните ваше имя</span>');
                }
            } else if(inputName == "PROP[PHONE]") {
                if(!regPhone.test(inputVal)) {
                    inputError = true;
                    $(this).before('<span class="error-input">Укажите корректный телефон</span>');
                }
            } else if(inputName == "PROP[EMAIL]") {
                if(!regMail.test(inputVal)) {
                    inputError = true;
                    $(this).before('<span class="error-input">Укажите корректный e-mail</span>');
                }
            }
        });
        if(inputError) return false;
    });

    $("input[type=text], textarea").focus(function(){
        $(this).parent().find(".error-input").remove();
    });
});